import { useQuery } from "@tanstack/react-query";
import { getWholesaleAccountingOverview } from "../services/wholesaleAccountingService";


// ✅ Add "all_time" here
export type PeriodType = "month" | "quarter" | "year" | "all_time";

export const useAccountingWholesale = (periodType: PeriodType) => {
  return useQuery({
    queryKey: ["wholesale-accounting_dashboard", periodType],
    queryFn: () => getWholesaleAccountingOverview(periodType),
    staleTime: 1000 * 60 * 5,
  });
};